import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule } from '@core/components';

import { ContentModule } from 'app/layout/components/content/content.module';
import { FooterModule } from 'app/layout/components/footer/footer.module';
import { HomeHeaderModule } from 'app/layout/components/home-header/home-header.module';

import { HomeLayoutComponent } from './home-layout.component';

@NgModule({
  declarations: [HomeLayoutComponent],
  imports: [RouterModule, CoreCommonModule, CoreSidebarModule, ContentModule, FooterModule, HomeHeaderModule],
  exports: [HomeLayoutComponent]
})
export class HomeLayoutModule {}
